"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _core = _interopRequireDefault(require("./core"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);
  }

  _createClass(Auth, null, [{
    key: "resource",
    get: // Getters & setters
    function get() {
      return _core["default"].store.get('core:auth:resource');
    },
    set: function set(value) {
      return _core["default"].store.set('core:auth:resource', value);
    }
  }, {
    key: "accesstoken",
    get: function get() {
      return _core["default"].store.get('core:auth:accesstoken');
    },
    set: function set(value) {
      return _core["default"].store.set('core:auth:accesstoken', value);
    }
  }, {
    key: "refreshtoken",
    get: function get() {
      return _core["default"].store.get('core:auth:refreshtoken');
    },
    set: function set(value) {
      return _core["default"].store.set('core:auth:refreshtoken', value);
    }
  }, {
    key: "expiry",
    get: function get() {
      return _core["default"].store.get('core:auth:expiry');
    },
    set: function set(value) {
      return _core["default"].store.set('core:auth:expiry', value);
    }
  }, {
    key: "authenticated",
    get: function get() {
      return _core["default"].store.get('core:auth:authenticated');
    },
    set: function set(value) {
      return _core["default"].store.set('core:auth:authenticated', value);
    } // Methods

  }, {
    key: "install",
    value: function install(Vue) {
      var _this = this;

      Vue.prototype.$auth = Auth; // Set authenticated to false first

      Auth.authenticated = false; // Listen to websocket state change

      _core["default"].eventhub.on("core:ws:".concat(_core["default"].ws.uri, ":state"), function (state, oldState) {
        // Check authenticated on reconnect
        if (state === true && oldState === false) {
          _this.checkAuthenticated();
        }
      });
    }
  }, {
    key: "signin",
    value: function () {
      var _signin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
        var signinResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                signinResult = null;
                _context.prev = 1;
                _context.next = 4;
                return _core["default"].ws.post('/auth/signin', {
                  body: {
                    username: username,
                    password: password
                  }
                });

              case 4:
                signinResult = _context.sent;

                if (!(_core["default"].permissions.enabled === true && _core["default"].permissions.getPermissionsOnEvent === 'auth')) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return _core["default"].permissions.getPermissions();

              case 8:
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);

                _core["default"].eventhub.emit('core:auth:authenticated', false);

                throw _context.t0;

              case 14:
                Auth.saveCredentials(signinResult);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      function signin(_x, _x2) {
        return _signin.apply(this, arguments);
      }

      return signin;
    }()
  }, {
    key: "saveCredentials",
    value: function saveCredentials(_ref) {
      var accesstoken = _ref.accesstoken,
          refreshtoken = _ref.refreshtoken,
          resource = _ref.resource,
          expiry = _ref.expiry;
      // Set auth
      Auth.resource = resource;
      Auth.accesstoken = accesstoken;
      Auth.refreshtoken = refreshtoken;
      Auth.expiry = Number(expiry);
      Auth.authenticated = Auth.resource ? true : false; // Set storage items

      window.localStorage.setItem('accesstoken', accesstoken);
      window.localStorage.setItem('refreshtoken', refreshtoken);
      window.localStorage.setItem('expiry', expiry);

      _core["default"].eventhub.emit('core:auth:authenticated', Auth.authenticated);
    }
  }, {
    key: "logout",
    value: function logout() {
      // Send request to backend for logout
      // We don't have to wait for it, because it doesn't matter that much if it succeeded for the frontend
      if (Auth.accesstoken) {
        _core["default"].ws.post('/auth/logout');
      } // Set library variables


      Auth.accesstoken = null;
      Auth.refreshtoken = null;
      Auth.resource = null;
      Auth.expiry = null;
      Auth.authenticated = false; // Remove storage items

      window.localStorage.removeItem('accesstoken');
      window.localStorage.removeItem('refreshtoken');
      window.localStorage.removeItem('expiry'); // Event

      _core["default"].eventhub.emit('core:auth:authenticated', Auth.authenticated);
    }
  }, {
    key: "checkAuthenticated",
    value: function () {
      var _checkAuthenticated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var options,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                // Initiate library
                Auth.accesstoken = window.localStorage.getItem('accesstoken');
                Auth.refreshtoken = window.localStorage.getItem('refreshtoken');
                Auth.expiry = Number(window.localStorage.getItem('expiry')); // Get resource

                if (!(Auth.accesstoken || Auth.refreshtoken)) {
                  _context2.next = 20;
                  break;
                }

                _context2.prev = 5;
                _context2.next = 8;
                return Auth.getResource(_objectSpread({}, options));

              case 8:
                Auth.resource = _context2.sent;

                if (!(_core["default"].permissions.enabled === true && _core["default"].permissions.getPermissionsOnEvent === 'auth')) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return _core["default"].permissions.getPermissions(_objectSpread({}, options));

              case 12:
                Auth.authenticated = true;
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](5);
                // Logout on error
                Auth.logout();

              case 18:
                _context2.next = 21;
                break;

              case 20:
                // Execute logout so everything is clear
                Auth.logout();

              case 21:
                _core["default"].eventhub.emit('core:auth:authenticated', Auth.authenticated);

                return _context2.abrupt("return", {
                  authenticated: Auth.authenticated
                });

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 15]]);
      }));

      function checkAuthenticated() {
        return _checkAuthenticated.apply(this, arguments);
      }

      return checkAuthenticated;
    }()
  }, {
    key: "shouldRefreshToken",
    value: function shouldRefreshToken() {
      if (!Auth.resource || !Auth.refreshtoken) {
        return false;
      }

      var currentTime = _momentTimezone["default"].utc().valueOf();

      var expiryMinus10Minutes = (0, _momentTimezone["default"])(Number(Auth.expiry)).subtract(10, 'minutes').valueOf();
      return currentTime >= expiryMinus10Minutes;
    } // Resource

  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      return Auth.authenticated === true;
    }
  }, {
    key: "getResource",
    value: function () {
      var _getResource = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var options,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                return _context3.abrupt("return", _core["default"].ws.get('/auth/resource', _objectSpread({}, options)));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getResource() {
        return _getResource.apply(this, arguments);
      }

      return getResource;
    }()
  }, {
    key: "isResourceFromIndex",
    value: function isResourceFromIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return Auth.resource && Auth.resource._meta.index === index;
    } // Permissions

  }, {
    key: "hasPermission",
    value: function hasPermission() {
      var neededPermissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return _core["default"].permissions.hasPermission(neededPermissions);
    }
  }]);

  return Auth;
}();

exports["default"] = Auth;